// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"684":"cba0e3fa","787":"3c228259"}[chunkId] + ".chunk.js";
};